/**
 * @generated SignedSource<<884ac7ef63912fafb8c5de6920a85f60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type topPage_indexQuery$variables = {}
export type topPage_indexQuery$data = {
  readonly ohakaPosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'PostListPieces_posts'>
  }
  readonly sougiPosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'PostListPieces_posts'>
  }
  readonly butsudanPosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'PostListPieces_posts'>
  }
  readonly souzokuPosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'PostListPieces_posts'>
  }
  readonly kaigoPosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'PostListPieces_posts'>
  }
  readonly cemeteryPosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'PostListPieces_posts'>
  }
  readonly pickUpPosts1: {
    readonly ' $fragmentSpreads': FragmentRefs<'PickUpPosts_posts'>
  }
  readonly pickUpPosts2: {
    readonly ' $fragmentSpreads': FragmentRefs<'PickUpPosts_posts'>
  }
  readonly pickUpPosts3: {
    readonly ' $fragmentSpreads': FragmentRefs<'PickUpPosts_posts'>
  }
  readonly pickUpPosts4: {
    readonly ' $fragmentSpreads': FragmentRefs<'PickUpPosts_posts'>
  }
  readonly pickUpPosts5: {
    readonly ' $fragmentSpreads': FragmentRefs<'PickUpPosts_posts'>
  }
  readonly newlyPosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'PostListCard_posts'>
  }
  readonly newlyCemeteryPosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'PostListCard_posts'>
  }
  readonly prefLink: {
    readonly items: ReadonlyArray<{
      readonly name: string
      readonly roma: string
      readonly shopCount: number
    }>
    readonly totalShopCount: number
  }
}
export type topPage_indexQuery = {
  variables: topPage_indexQuery$variables
  response: topPage_indexQuery$data
}

const node: ConcreteRequest = (function () {
  var v0 = {
      kind: 'Literal',
      name: 'filter',
      value: {
        parent_slugs: ['ohaka']
      }
    },
    v1 = {
      kind: 'Literal',
      name: 'page',
      value: {
        from: 0,
        size: 4
      }
    },
    v2 = [v0 /*: any*/, v1 /*: any*/],
    v3 = [
      {
        args: null,
        kind: 'FragmentSpread',
        name: 'PostListPieces_posts'
      }
    ],
    v4 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          parent_slugs: ['sougi']
        }
      },
      v1 /*: any*/
    ],
    v5 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          parent_slugs: ['butsudan']
        }
      },
      v1 /*: any*/
    ],
    v6 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          parent_slugs: ['souzoku']
        }
      },
      v1 /*: any*/
    ],
    v7 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          parent_slugs: ['kaigo']
        }
      },
      v1 /*: any*/
    ],
    v8 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          parent_slugs: ['cemetery-top']
        }
      },
      v1 /*: any*/
    ],
    v9 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          slugs: ['ohaka', 'ohaka-price', 'ohaka-search']
        }
      }
    ],
    v10 = [
      {
        args: null,
        kind: 'FragmentSpread',
        name: 'PickUpPosts_posts'
      }
    ],
    v11 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          slugs: ['jumokusou', 'jumokusou-price', 'jumokusou-kakuyasu']
        }
      }
    ],
    v12 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          slugs: ['noukotsudou', 'noukotsudou-price', 'ohaka-mansion']
        }
      }
    ],
    v13 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          slugs: ['eitaikuyou-meaning', 'eitaikuyou-price', 'ohaka-nothing']
        }
      }
    ],
    v14 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          slugs: ['ohaka-jimai-price', 'ohaka-kaisou', 'eitaikuyou-hakajimai']
        }
      }
    ],
    v15 = {
      kind: 'Literal',
      name: 'page',
      value: {
        from: 0,
        size: 5
      }
    },
    v16 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          template_name: 'show_post'
        }
      },
      v15 /*: any*/
    ],
    v17 = [
      {
        args: null,
        kind: 'FragmentSpread',
        name: 'PostListCard_posts'
      }
    ],
    v18 = [v0 /*: any*/, v15 /*: any*/],
    v19 = {
      alias: 'prefLink',
      args: [
        {
          kind: 'Literal',
          name: 'limit',
          value: 99
        }
      ],
      concreteType: 'PrefectureWithShopCountConnection',
      kind: 'LinkedField',
      name: 'listPrefecturesWithShopCount',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          concreteType: 'PrefectureWithShopCount',
          kind: 'LinkedField',
          name: 'items',
          plural: true,
          selections: [
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'name',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'roma',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'shopCount',
              storageKey: null
            }
          ],
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'totalShopCount',
          storageKey: null
        }
      ],
      storageKey: 'listPrefecturesWithShopCount(limit:99)'
    },
    v20 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'slug',
      storageKey: null
    },
    v21 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'h1',
      storageKey: null
    },
    v22 = {
      alias: null,
      args: null,
      concreteType: 'PostImage',
      kind: 'LinkedField',
      name: 'image',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'url',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'alt',
          storageKey: null
        }
      ],
      storageKey: null
    },
    v23 = [
      {
        alias: null,
        args: null,
        concreteType: 'Post',
        kind: 'LinkedField',
        name: 'items',
        plural: true,
        selections: [
          v20 /*: any*/,
          v21 /*: any*/,
          v22 /*: any*/,
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'modified_at',
            storageKey: null
          }
        ],
        storageKey: null
      }
    ],
    v24 = [
      {
        alias: null,
        args: null,
        concreteType: 'Post',
        kind: 'LinkedField',
        name: 'items',
        plural: true,
        selections: [v20 /*: any*/, v21 /*: any*/, v22 /*: any*/],
        storageKey: null
      }
    ],
    v25 = [
      {
        alias: null,
        args: null,
        concreteType: 'Post',
        kind: 'LinkedField',
        name: 'items',
        plural: true,
        selections: [v21 /*: any*/, v20 /*: any*/, v22 /*: any*/],
        storageKey: null
      }
    ]
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'topPage_indexQuery',
      selections: [
        {
          alias: 'ohakaPosts',
          args: v2 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v3 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["ohaka"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'sougiPosts',
          args: v4 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v3 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["sougi"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'butsudanPosts',
          args: v5 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v3 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["butsudan"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'souzokuPosts',
          args: v6 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v3 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["souzoku"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'kaigoPosts',
          args: v7 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v3 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["kaigo"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'cemeteryPosts',
          args: v8 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v3 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["cemetery-top"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'pickUpPosts1',
          args: v9 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v10 /*: any*/,
          storageKey:
            'listPosts(filter:{"slugs":["ohaka","ohaka-price","ohaka-search"]})'
        },
        {
          alias: 'pickUpPosts2',
          args: v11 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v10 /*: any*/,
          storageKey:
            'listPosts(filter:{"slugs":["jumokusou","jumokusou-price","jumokusou-kakuyasu"]})'
        },
        {
          alias: 'pickUpPosts3',
          args: v12 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v10 /*: any*/,
          storageKey:
            'listPosts(filter:{"slugs":["noukotsudou","noukotsudou-price","ohaka-mansion"]})'
        },
        {
          alias: 'pickUpPosts4',
          args: v13 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v10 /*: any*/,
          storageKey:
            'listPosts(filter:{"slugs":["eitaikuyou-meaning","eitaikuyou-price","ohaka-nothing"]})'
        },
        {
          alias: 'pickUpPosts5',
          args: v14 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v10 /*: any*/,
          storageKey:
            'listPosts(filter:{"slugs":["ohaka-jimai-price","ohaka-kaisou","eitaikuyou-hakajimai"]})'
        },
        {
          alias: 'newlyPosts',
          args: v16 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v17 /*: any*/,
          storageKey:
            'listPosts(filter:{"template_name":"show_post"},page:{"from":0,"size":5})'
        },
        {
          alias: 'newlyCemeteryPosts',
          args: v18 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v17 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["ohaka"]},page:{"from":0,"size":5})'
        },
        v19 /*: any*/
      ],
      type: 'Query',
      abstractKey: null
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'topPage_indexQuery',
      selections: [
        {
          alias: 'ohakaPosts',
          args: v2 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v23 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["ohaka"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'sougiPosts',
          args: v4 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v23 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["sougi"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'butsudanPosts',
          args: v5 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v23 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["butsudan"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'souzokuPosts',
          args: v6 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v23 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["souzoku"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'kaigoPosts',
          args: v7 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v23 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["kaigo"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'cemeteryPosts',
          args: v8 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v23 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["cemetery-top"]},page:{"from":0,"size":4})'
        },
        {
          alias: 'pickUpPosts1',
          args: v9 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v24 /*: any*/,
          storageKey:
            'listPosts(filter:{"slugs":["ohaka","ohaka-price","ohaka-search"]})'
        },
        {
          alias: 'pickUpPosts2',
          args: v11 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v24 /*: any*/,
          storageKey:
            'listPosts(filter:{"slugs":["jumokusou","jumokusou-price","jumokusou-kakuyasu"]})'
        },
        {
          alias: 'pickUpPosts3',
          args: v12 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v24 /*: any*/,
          storageKey:
            'listPosts(filter:{"slugs":["noukotsudou","noukotsudou-price","ohaka-mansion"]})'
        },
        {
          alias: 'pickUpPosts4',
          args: v13 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v24 /*: any*/,
          storageKey:
            'listPosts(filter:{"slugs":["eitaikuyou-meaning","eitaikuyou-price","ohaka-nothing"]})'
        },
        {
          alias: 'pickUpPosts5',
          args: v14 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v24 /*: any*/,
          storageKey:
            'listPosts(filter:{"slugs":["ohaka-jimai-price","ohaka-kaisou","eitaikuyou-hakajimai"]})'
        },
        {
          alias: 'newlyPosts',
          args: v16 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v25 /*: any*/,
          storageKey:
            'listPosts(filter:{"template_name":"show_post"},page:{"from":0,"size":5})'
        },
        {
          alias: 'newlyCemeteryPosts',
          args: v18 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v25 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["ohaka"]},page:{"from":0,"size":5})'
        },
        v19 /*: any*/
      ]
    },
    params: {
      cacheID: '59971c72112f43d71cb21b13d9cc743b',
      id: null,
      metadata: {},
      name: 'topPage_indexQuery',
      operationKind: 'query',
      text: 'query topPage_indexQuery {\n  ohakaPosts: listPosts(filter: {parent_slugs: ["ohaka"]}, page: {from: 0, size: 4}) {\n    ...PostListPieces_posts\n  }\n  sougiPosts: listPosts(filter: {parent_slugs: ["sougi"]}, page: {from: 0, size: 4}) {\n    ...PostListPieces_posts\n  }\n  butsudanPosts: listPosts(filter: {parent_slugs: ["butsudan"]}, page: {from: 0, size: 4}) {\n    ...PostListPieces_posts\n  }\n  souzokuPosts: listPosts(filter: {parent_slugs: ["souzoku"]}, page: {from: 0, size: 4}) {\n    ...PostListPieces_posts\n  }\n  kaigoPosts: listPosts(filter: {parent_slugs: ["kaigo"]}, page: {from: 0, size: 4}) {\n    ...PostListPieces_posts\n  }\n  cemeteryPosts: listPosts(filter: {parent_slugs: ["cemetery-top"]}, page: {from: 0, size: 4}) {\n    ...PostListPieces_posts\n  }\n  pickUpPosts1: listPosts(filter: {slugs: ["ohaka", "ohaka-price", "ohaka-search"]}) {\n    ...PickUpPosts_posts\n  }\n  pickUpPosts2: listPosts(filter: {slugs: ["jumokusou", "jumokusou-price", "jumokusou-kakuyasu"]}) {\n    ...PickUpPosts_posts\n  }\n  pickUpPosts3: listPosts(filter: {slugs: ["noukotsudou", "noukotsudou-price", "ohaka-mansion"]}) {\n    ...PickUpPosts_posts\n  }\n  pickUpPosts4: listPosts(filter: {slugs: ["eitaikuyou-meaning", "eitaikuyou-price", "ohaka-nothing"]}) {\n    ...PickUpPosts_posts\n  }\n  pickUpPosts5: listPosts(filter: {slugs: ["ohaka-jimai-price", "ohaka-kaisou", "eitaikuyou-hakajimai"]}) {\n    ...PickUpPosts_posts\n  }\n  newlyPosts: listPosts(filter: {template_name: "show_post"}, page: {from: 0, size: 5}) {\n    ...PostListCard_posts\n  }\n  newlyCemeteryPosts: listPosts(filter: {parent_slugs: ["ohaka"]}, page: {from: 0, size: 5}) {\n    ...PostListCard_posts\n  }\n  prefLink: listPrefecturesWithShopCount(limit: 99) {\n    items {\n      name\n      roma\n      shopCount\n    }\n    totalShopCount\n  }\n}\n\nfragment PickUpPosts_posts on PostResult {\n  items {\n    slug\n    h1\n    image {\n      url\n      alt\n    }\n  }\n}\n\nfragment PostListCard_posts on PostResult {\n  items {\n    h1\n    slug\n    image {\n      url\n      alt\n    }\n  }\n}\n\nfragment PostListPieces_posts on PostResult {\n  items {\n    slug\n    h1\n    image {\n      url\n      alt\n    }\n    modified_at\n  }\n}\n'
    }
  }
})()

;(node as any).hash = '5ae07d00db95d99f8320c0c940ade98d'

export default node
